<div class="d-lg-block d-none">
  <fgb-banner [title]="'earn.page.banner' | translate"></fgb-banner>
</div>

<div class="d-lg-none">
  <fgb-mobile-page-header
    pageTitle="earn.page.banner"
    [showFooter]="true"
    [showQr]="false"
    [showBalance]="false"
    [backButtonLink]="'/'"
  ></fgb-mobile-page-header>
</div>

<div class="container mt-lg-4" [ngClass]="isCorporate ? 'corporate-colors' : 'default-color'">
  <fgbcl-earn-points [lgWidth]="'6'"></fgbcl-earn-points>
</div>
